// the kinds of insight the performance summary and the metric insights page show (BE's insight type)
export const enum InsightType {
	// Home Performance Summary
	POSITIVE = 'positive',
	NEGATIVE = 'negative',
	AVG = 'average',
	// Metric Insights page - Single output (+ AVG - already declared above)
	HIGHEST_VALUE = 'highest-value',
	LOWEST_VALUE = 'lowest-value',
	ABSOLUTE_CHANGE_PREVIOUS_PERIOD = 'absolute-change-previous-period',
	PERCENT_CHANGE_LAST_YEAR = 'percent-change-last-year',
	// Metric Insights page - Multiple output (more than 1 attribute / unit selected, including all)
	DIMENSIONAL_POSITIVE_CHANGE_HIGHEST = 'dimensional-positive-change-highest',
	DIMENSIONAL_NEGATIVE_CHANGE_HIGHEST = 'dimensional-negative-change-highest',
	DIMENSIONAL_POSITIVE_CHANGE_LOWEST = 'dimensional-positive-change-lowest',
	DIMENSIONAL_AVERAGE_HIGHEST = 'dimensional-average-highest',
	DIMENSIONAL_AVERAGE_LOWEST = 'dimensional-average-lowest',
}
